import React from 'react'

/**
 * Logo cell renderer component
 * @param {string} imageUrl - Logo image URL
 * @param {string} imageAlt - Alt text for the image
 * @param {function} onClick - Click handler function (imageUrl, imageAlt) => {}
 * @param {object} style - Custom styles for the container
 */
export const LogoCellRenderer = ({ imageUrl, imageAlt = 'Logo', onClick = null, style = {} }) => {
  const defaultStyle = {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...style
  }

  const handleClick = () => {
    if (onClick && imageUrl) {
      onClick(imageUrl, imageAlt)
    }
  }

  return (
    <div style={defaultStyle}>
      {imageUrl ? (
        <>
          <img 
            src={imageUrl} 
            alt={imageAlt} 
            style={{ 
              maxWidth: '100%', 
              maxHeight: '100%', 
              objectFit: 'contain',
              cursor: onClick ? 'pointer' : 'default',
              transition: 'transform 0.2s'
            }}
            onClick={handleClick}
            onMouseEnter={(e) => {
              if (onClick) {
                e.target.style.transform = 'scale(1.1)'
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)'
            }}
            onError={(e) => {
              e.target.style.display = 'none'
              if (e.target.nextElementSibling) {
                e.target.nextElementSibling.style.display = 'flex'
              }
            }}
          />
          <div style={{ 
            display: 'none', 
            width: '40px', 
            height: '40px', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px'
          }}>
            <i className="zmdi zmdi-city" style={{ fontSize: '24px', color: '#999' }}></i>
          </div>
        </>
      ) : (
        <div style={{ 
          display: 'flex', 
          width: '40px', 
          height: '40px', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          borderRadius: '4px'
        }}>
          <i className="zmdi zmdi-city" style={{ fontSize: '24px', color: '#999' }}></i>
        </div>
      )}
    </div>
  )
}

/**
 * Badge cell renderer component
 * @param {boolean|string} value - Value to display
 * @param {object} options - { trueLabel: 'Aktif', falseLabel: 'Pasif', trueClass: 'badge-success', falseClass: 'badge-danger' }
 */
export const BadgeCellRenderer = ({ value, options = {} }) => {
  const {
    trueLabel = 'Aktif',
    falseLabel = 'Pasif',
    trueClass = 'badge-success',
    falseClass = 'badge-danger'
  } = options

  const isTrue = value === true || value === 'true' || value === 1 || value === '1'
  
  return (
    <span className={`badge ${isTrue ? trueClass : falseClass}`}>
      {isTrue ? trueLabel : falseLabel}
    </span>
  )
}

